// extracted by mini-css-extract-plugin
export var linkText = "_p5-0";